import Vue, { PluginObject } from 'vue';
declare const bootstrap: any;
interface ToastOptions { title?: string; variant?: string; autohide?: boolean; delay?: number; }

const ToastPlugin: PluginObject<any> = {
    install(vue) {
        const containerId = 'toast-root';

        function ensureContainer(): HTMLElement {
            let el = document.getElementById(containerId);
            if (!el) {
                el = document.createElement('div');
                el.id = containerId;
                el.className = 'toast-container position-fixed top-0 end-0 p-3';
                document.body.appendChild(el);
            }
            return el;
        }

        function show(message: string, opts: ToastOptions = {}) {
            const { title = "Notice", variant = "primary", autohide = true, delay = 5000 } = opts;

            const container = ensureContainer();
            const toastEl = document.createElement('div');
            toastEl.className = "toast fade custom-slide-toast";
            toastEl.setAttribute('role', 'alert');
            toastEl.setAttribute('aria-live', 'assertive');
            toastEl.setAttribute('aria-atomic', 'true');

            toastEl.innerHTML = `
              <div class="toast-header bg-${variant} text-white">
                <strong class="me-auto">${title}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast"></button>
              </div>
              <div class="toast-body">${message}</div>
            `;
            container.appendChild(toastEl);

            void toastEl.offsetHeight;

            const toast = new bootstrap.Toast(toastEl, { autohide, delay });
            toast.show();

            toastEl.addEventListener('hidden.bs.toast', () => toastEl.remove());
        }


        vue.prototype.$toast = {
            show,
            success(msg: string, title = "Success", autoHide = true) { show(msg, { title, variant: "success", autohide: autoHide }); },
            error(msg: string, title = "Error", autoHide = true) { show(msg, { title, variant: "danger", autohide: autoHide }); },
            info(msg: string, title = "Info", autoHide = true) { show(msg, { title, variant: "info", autohide: autoHide }); },
            warn(msg: string, title = "Warning", autoHide = true) { show(msg, { title, variant: "warning", autohide: autoHide }); }
        };
    }
};

export default ToastPlugin;